// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__hk2uq","header":"MergedInvoice_header__4S1yU"};